import { createSlice } from "@reduxjs/toolkit";

export const initialState = {
    customerTagStatusCount : [],
    loading : false,
    error : null,
};

const fetchCustomerCountSlice = createSlice({
    name:"customerTagCount",
    initialState,
    reducers: {
        fetchCustomerCountSuccess: (state,action) => {
            state.loading = false;
            state.customerTagStatusCount = action.payload
        },
        fetchCustomerCountFailure: (state,action) => {
            state.loading = false;
            state.error = action.payload
        }
    }
})

export const {
    fetchCustomerCountFailure,
    fetchCustomerCountSuccess
} = fetchCustomerCountSlice.actions

export default fetchCustomerCountSlice.reducer